import "./chunk-BBZEL7EG.js";

// src/useThemeMode.ts
import { useColorScheme } from "@mui/joy/styles";
var useThemeMode = () => {
  const { mode, systemMode } = useColorScheme();
  switch (mode) {
    case "system":
      return systemMode === "light" ? "light" : "dark";
    case "light":
      return "light";
    case "dark":
    case void 0:
      return "dark";
  }
};
export {
  useThemeMode
};
